<template>
  <div class="container-fluid">
    <form
      class="tab-content py-3"
      id="wizardSteps"
      @submit.prevent="onCreateConfig()"
    >
      <div
        class="tab-pane fade m-5 show active"
        id="wizardStepOne"
        role="tabpanel"
        aria-labelledby="wizardTabOne"
      >
        <!-- Header -->
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            <!-- Pretitle -->
            <h6 class="mb-4 text-uppercase text-muted">
              Step 1 of {{ totalSteps }}
            </h6>
            <!-- Title -->
            <h1 class="mb-3">
              <!-- Let’s start with template creation. -->
              Select IDR Edge Extract job
            </h1>
            <!-- Subtitle -->
            <!-- <p class="mb-5 text-muted">Description</p> -->
          </div>
        </div>
        <div class="row justify-content-center my-5">
          <div class="col-6">
            <select
              name="limit"
              class="form-select form-select-sm"
              v-model="idrEdge"
            >
              <option
                v-for="option in this.jobOptions"
                :key="option.index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        <!-- Divider -->
        <hr class="my-5" />

        <!-- Footer -->
        <div class="nav row align-items-center">
          <div class="col-auto">
            <!-- Button -->
            <button
              class="btn btn-lg btn-white"
              type="reset"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
          <div class="col text-center">
            <h6 class="text-uppercase text-muted mb-0">
              Step 1 of {{ totalSteps }}
            </h6>
          </div>
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-primary"
              data-toggle="wizard"
              href="#wizardStepTwo"
              role="button"
              >Continue</a
            >
          </div>
        </div>
      </div>
      <!-- Data Source Step -->
      <div
        class="tab-pane fade m-5"
        id="wizardStepTwo"
        role="tabpanel"
        aria-labelledby="wizardTabTwo"
      >
        <!-- Header -->
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            <!-- Pretitle -->
            <h6 class="mb-4 text-uppercase text-muted">
              Step 2 of {{ totalSteps }}
            </h6>
            <!-- Title -->
            <h1 class="mb-3">
              <!-- Let’s start with template creation. -->
              Begin by Creating Determisnistic Pipeline
            </h1>
            <!-- Subtitle -->
            <!-- <p class="mb-5 text-muted">Description</p> -->
          </div>
        </div>
        <!-- / .row -->

        <div class="confg-div">
          <!-- Mode Selection -->
          <div class="mb-3">
            <label class="form-label">Mode</label>
            <div class="btn-group mx-3" role="group">
              <input
                type="radio"
                class="btn-check"
                name="mode"
                id="mode-edges"
                v-model="deterministicConfig.mode"
                value="edges"
              />
              <label class="btn btn-outline-primary" for="mode-edges"
                >Edges</label
              >

              <input
                type="radio"
                class="btn-check"
                name="mode"
                id="mode-attrs"
                v-model="deterministicConfig.mode"
                value="attrs"
              />
              <label class="btn btn-outline-primary" for="mode-attrs"
                >Attrs</label
              >
            </div>
          </div>

          <!-- Snapshot Operation -->
          <div class="mb-3">
            <label class="form-label">Snapshot Operation</label>
            <select
              class="form-select"
              v-model="deterministicConfig.snapshot_operation"
            >
              <option value="add">Add</option>
              <option value="replace">Replace</option>
            </select>
          </div>

          <!-- All Diff Toggle -->
          <div class="mb-3 form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="allDiff"
              v-model="deterministicConfig.all_diff"
            />
            <label class="form-check-label" for="allDiff">All Diff</label>
          </div>

          <!-- Version Controls -->
          <div class="row mb-3">
            <div class="col">
              <label class="form-label">Input Snapshot Version</label>
              <select
                class="form-select"
                v-model="deterministicConfig.input_snapshot_version"
              >
                <option value="v3">v3</option>
                <option value="v6">v6</option>
              </select>
            </div>
            <div class="col">
              <label class="form-label">Aqfer Graph Input Version</label>
              <select
                class="form-select"
                v-model="deterministicConfig.aqfer_graph_input_version"
              >
                <option value="v3">v3</option>
                <option value="v6">v6</option>
              </select>
            </div>
            <div class="col">
              <label class="form-label">Output Snapshot Version</label>
              <select
                class="form-select"
                v-model="deterministicConfig.output_snapshot_version"
              >
                <option value="v3">v3</option>
                <option value="v6">v6</option>
              </select>
            </div>
          </div>

          <!-- TTL Input -->
          <div class="mb-3">
            <label class="form-label">TTL (hours)</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                v-model="deterministicConfig.ttl"
                placeholder="Enter hours"
              />
              <span class="input-group-text"></span>
            </div>
            <small class="form-text text-muted">Leave empty for no TTL</small>
          </div>

          <!-- Collision Algorithm -->
          <div class="mb-3">
            <label class="form-label">On Collision Algorithm</label>
            <select
              class="form-select"
              v-model="deterministicConfig.on_collision.algo"
            >
              <option value="default">Default</option>
              <option value="latest_timestamp">Latest Timestamp</option>
            </select>
          </div>

          <!-- Capture Partition Keys Toggle -->
          <div class="mb-3 form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="capturePartitionKeys"
              v-model="deterministicConfig.capture_partition_keys"
            />
            <label class="form-check-label" for="capturePartitionKeys">
              Capture Partition Keys
            </label>
          </div>
        </div>

        <!-- Divider -->
        <hr class="my-5" />

        <!-- Footer -->
        <div class="nav row align-items-center">
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-white"
              data-toggle="wizard"
              href="#wizardStepOne"
              >Back</a
            >
          </div>
          <div class="col text-center">
            <!-- Step -->
            <h6 class="text-uppercase text-muted mb-0">
              Step 2 of {{ totalSteps }}
            </h6>
          </div>
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-primary"
              data-toggle="wizard"
              href="#wizardStepThree"
              role="button"
              >Continue</a
            >
          </div>
        </div>
      </div>

      <!-- Deterministic Pipeline Step -->
      <div
        class="tab-pane fade m-5"
        id="wizardStepThree"
        role="tabpanel"
        aria-labelledby="wizardTabThree"
      >
        <!-- Header -->
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            <!-- Pretitle -->
            <h6 class="mb-4 text-uppercase text-muted">
              Step 3 of {{ totalSteps }}
            </h6>
            <!-- Title -->
            <h1 class="mb-3">Create Cluster Pipeline</h1>
            <!-- Subtitle -->
            <!-- <p class="mb-5 text-muted">description</p> -->
          </div>
        </div>
        <!-- / .row -->
        <div class="confg-div">
          <!-- Mode Selection -->
          <div class="mb-2">
            <label class="form-label">Mode</label>
            <select class="form-select" v-model="clusterModeConfig.mode">
              <option value="cluster_graph">Cluster Graph</option>
            </select>
          </div>
          <!-- Cluster Graph Configuration -->
          <div class="card mb-2">
            <div class="card-header">
              <h5 class="mb-0">Flatten Graph</h5>
            </div>
            <div class="card-body row">
              <!-- Quarantine All Toggle -->
              <div class="mbform-check col">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="quarantineAll"
                  v-model="
                    clusterModeConfig.cluster_graph.flatten_graph
                      .flatten_graph_quarantine_all
                  "
                />
                <label class="form-check-label mx-2" for="quarantineAll">
                  Quarantine All
                </label>
              </div>

              <!-- Edges Threshold -->
              <div class="mb-2 col">
                <label class="form-label">Edges Threshold</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="
                    clusterModeConfig.cluster_graph.flatten_graph
                      .flatten_graph_edges_threshold
                  "
                  placeholder="Default: 25"
                />
              </div>
            </div>
          </div>

          <!-- Create Cluster Section -->
          <div class="card mb-2">
            <div class="card-header">
              <h5 class="mb-0">Create Cluster</h5>
            </div>
            <div class="card-body row">
              <!-- Edges Threshold -->
              <div class="col-6 mb-2">
                <label class="form-label">Edges Threshold</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="
                    clusterModeConfig.cluster_graph.create_cluster
                      .create_cluster_edges_threshold
                  "
                  placeholder="Default: 10"
                />
              </div>
              <!-- TTL -->
              <div class="col-6 mb-2">
                <label class="form-label">TTL (hours)</label>
                <div class="input-group">
                  <input
                    type="number"
                    class="form-control"
                    v-model="clusterModeConfig.cluster_graph.create_cluster.ttl"
                    placeholder="Enter hours"
                  />
                  <span class="input-group-text"></span>
                </div>
              </div>

              <!-- Nodes Config File -->
              <!-- <div class="col">
								<label class="form-label">Nodes Config File</label>
								<div class="input-group">
									<input type="text" 
										class="form-control" 
										v-model="clusterModeConfig.cluster_graph.create_cluster.nodes_config_file"
										placeholder="nodes.yaml">
									<button class="btn btn-outline-secondary" type="button">
										Browse
									</button>
								</div>
							</div> -->
            </div>
          </div>

          <!-- Choose Cluster Section -->
          <div class="card mb-2">
            <div class="card-header">
              <h5 class="mb-0">Choose Cluster</h5>
            </div>
            <div class="card-body row">
              <!-- Cluster Type -->
              <div class="col">
                <label class="form-label">Cluster Type</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="
                    clusterModeConfig.cluster_graph.choose_cluster
                      .choose_cluster_type
                  "
                  placeholder="Enter cluster type"
                />
              </div>

              <!-- Cluster Domain -->
              <div class="col">
                <label class="form-label">Cluster Domain</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="
                    clusterModeConfig.cluster_graph.choose_cluster
                      .choose_cluster_domain
                  "
                  placeholder="Enter cluster domain"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Divider -->
        <hr class="my-5" />

        <!-- Footer -->
        <div class="nav row align-items-center">
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-white"
              data-toggle="wizard"
              href="#wizardStepTwo"
              >Back</a
            >
          </div>
          <div class="col text-center">
            <!-- Step -->
            <h6 class="text-uppercase text-muted mb-0">
              Step 3 of {{ totalSteps }}
            </h6>
          </div>
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-primary"
              data-toggle="wizard"
              href="#wizardStepFour"
              role="button"
              >Continue</a
            >
          </div>
        </div>
      </div>

      <!-- Cluster Node Config Step -->
      <div
        class="tab-pane fade m-5"
        id="wizardStepFour"
        role="tabpanel"
        aria-labelledby="wizardTabFour"
      >
        <!-- Header -->
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            <!-- Pretitle -->
            <h6 class="mb-4 text-uppercase text-muted">
              Step 4 of {{ totalSteps }}
            </h6>
            <!-- Title -->
            <h1 class="mb-3">
              <!-- Let’s start with template creation. -->
              Cluster Node Config
            </h1>
            <!-- Subtitle -->
            <!-- <p class="mb-5 text-muted">Description</p> -->
          </div>
        </div>
        <!-- / .row -->

        <div class="cluster-config-div">
          <!-- Push All Nodes Toggles -->
          <div class="mb-4">
            <div class="form-check mb-2">
              <input
                type="checkbox"
                class="form-check-input"
                id="pushToCluster"
                v-model="cluster_node_config.push_all_nodes_to_cluster"
              />
              <label class="form-check-label" for="pushToCluster">
                Push All Nodes to Cluster
              </label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="pushToReverseMapping"
                v-model="cluster_node_config.push_all_nodes_to_reverse_mapping"
              />
              <label class="form-check-label" for="pushToReverseMapping">
                Push All Nodes to Reverse Mapping
              </label>
            </div>
          </div>

          <!-- Weightage Map -->
          <label class="form-label">Weightage Map</label>
          <div class="row justify-content-center">
            <div class="col-6">
              <div class="weightage-entries">
                <!-- Existing weightage entries -->
                <div
                  v-for="(weight, key) in cluster_node_config.weightage_map"
                  :key="key"
                  class="input-group mb-2"
                >
                  <span class="input-group-text">{{ key }}</span>
                  <input
                    :id="weight"
                    class="form-control"
                    :value="cluster_node_config.weightage_map[key]"
                    :placeholder="'Enter weight for ' + key"
                    @keydown.enter.stop.prevent="
                      (event) => handleEnter(event, key)
                    "
                  />
                  <span class="input-group-text">%</span>
                  <button
                    class="btn btn-primary"
                    @click="deleteWeightageEntry(key)"
                  >
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <!-- Add new weightage entry -->
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="newWeightageKey"
                    placeholder="Enter new key"
                  />
                  <input
                    type="number"
                    class="form-control"
                    v-model="newWeightageValue"
                    placeholder="Enter weight"
                  />
                  <button
                    class="btn btn-primary"
                    @click="addWeightageEntry"
                    :disabled="!newWeightageKey || !newWeightageValue"
                  >
                    <i class="fas fa-plus"></i> Add
                  </button>
                </div>
              </div>

              <!-- <div class="weightage-entries">
								<div v-for="(weight, key) in cluster_node_config.weightage_map" 
									:key="key" 
									class="input-group mb-2">
									<span class="input-group-text">{{ key }}</span>
									<input  
										:id="weight"
										class="form-control" 
										:value="cluster_node_config.weightage_map[key]" 									
										:placeholder="'Enter weight for ' + key"									
										@keydown.enter.stop.prevent="(event) => handleEnter(event, key)"/>
									<span class="input-group-text">%</span>
								</div>
							</div>							 -->
            </div>
            <div class="col-6">
              <div class="network-wrapper">
                <div ref="networkContainer" class="network-container d-flex justify-content-center"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Divider -->
        <hr class="my-5" />

        <!-- Footer -->
        <div class="nav row align-items-center">
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-white"
              data-toggle="wizard"
              href="#wizardStepThree"
              >Back</a
            >
          </div>
          <div class="col text-center">
            <!-- Step -->
            <h6 class="text-uppercase text-muted mb-0">
              Step 4 of {{ totalSteps }}
            </h6>
          </div>
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-primary"
              data-toggle="wizard"
              href="#wizardStepFive"
              role="button"
              >Continue</a
            >
          </div>
        </div>
      </div>

      <div
        class="tab-pane fade m-5"
        id="wizardStepFive"
        role="tabpanel"
        aria-labelledby="wizardTabFive"
      >
        <!-- Header -->
        <div class="row justify-content-center">
          <div class="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
            <!-- Pretitle -->
            <h6 class="mb-4 text-uppercase text-muted">
              Step 5 of {{ totalSteps }}
            </h6>
            <!-- Title -->
            <h1 class="mb-3">Flowset</h1>
            <!-- Subtitle -->
            <p class="mb-5 text-muted"></p>
          </div>
        </div>
        <div class="row">
          <div class="nav d-grid gap-2 col-12 ms-4">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-4">
                  <h3 for="exampleFormControlInput1" class="form-label">
                    Name
                  </h3>
                  <input
                    class="form-control"
                    id="exampleFormControlInput1"
                    v-model="name"
                    placeholder="Enter name for the flowset"
                  />
                  <h3 for="exampleFormControlInput2" class="form-label mt-4">
                    Sandbox
                  </h3>
                  <select
                    id="exampleFormControlInput2"
                    class="form-select"
                    v-model="sandbox"
                  >
                    <!-- list only dev sandboxes option -->
                    <option
                      v-for="option in this.$store.state.sandbox.devSandboxes"
                      :key="option.name"
                      :value="option.name"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div class="nav row align-items-center">
          <div class="col-auto">
            <!-- Button -->
            <a
              class="btn btn-lg btn-white"
              data-toggle="wizard"
              href="#wizardStepFour"
              >Back</a
            >
          </div>
          <div class="col text-center">
            <!-- Step -->
            <h6 class="text-uppercase text-muted mb-0">
              Step 5 of {{ totalSteps }}
            </h6>
          </div>
          <div class="col-auto">
            <div class="col-auto">
              <!-- Button -->
              <button class="btn btn-lg btn-primary" type="submit">
                <div
                  v-if="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>Create</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Tab } from "bootstrap";
import { mapActions, mapState } from "vuex";
import { isDuplicate } from "../../utils/commonFunction";
import * as d3 from "d3"
export default {
  data() {
    return {
      configuration: {},
      name: null,
      sandbox: "",
      loading: false,
      deterministicConfig: {
        mode: "edges",
        snapshot_operation: "add",
        all_diff: false,
        input_snapshot_version: "v3",
        aqfer_graph_input_version: "v3",
        output_snapshot_version: "v3",
        ttl: null,
        on_collision: {
          algo: "default",
        },
        capture_partition_keys: false,
      },

      clusterModeConfig: {
        mode: "cluster_graph",
        cluster_graph: {
          flatten_graph: {
            flatten_graph_quarantine_all: false,
            flatten_graph_edges_threshold: 25,
          },
          create_cluster: {
            create_cluster_edges_threshold: 10,
            nodes_config_file: "nodes.yaml",
            ttl: null,
          },
          choose_cluster: {
            choose_cluster_type: "",
            choose_cluster_domain: "",
          },
          final_graph: {
            nodes_config_file: "nodes.yaml",
          },
        },
      },

      cluster_node_config: {
        push_all_nodes_to_cluster: false,
        push_all_nodes_to_reverse_mapping: false,
        weightage_map: {
          "raw~EMAIL": 95,
          "prsn~AQFER": 85,
          "ipv4~HTTP_INFO": 75,
          "statid~c900_z__z__z_palgo1_z_": 60,
          "ck~c900_z__z_aqfer.net_z___aqid_z_": 50,
          "ip~c900_z__z__z__z_md5": 45,
        },
      },

      flowset: null,
      idrEdge: null,
      totalSteps: 5,
      templateDynamicFields: {},
      mappingResponse: null,
      cid: this.$route.params.cid,
      network: null,
      options: {
        layout: {
          randomSeed: 1, // Consistent layout
          improvedLayout: true,
        },
        nodes: {
          shape: "dot",
          font: {
            size: 14,
          },
        },
        interaction: {
          hover: true,
          tooltipDelay: 300,
        },
        physics: {
          stabilization: {
            enabled: true,
            fit: true, // Ensures graph fits in container
          },
        },
        autoResize: true,
        height: "100%",
        width: "100%",
      },
      newWeightageKey: "",
      newWeightageValue: "",
    };
  },

  mounted() {
    // this.getJobTemplates();
    const toggles = document.querySelectorAll('[data-toggle="wizard"]');
    toggles.forEach((toggle) => {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        // Toggle new tab
        const tab = new Tab(toggle);
        tab.show();
        // Remove active state
        toggle.classList.remove("active");
      });
    });
    this.$nextTick(() => {
      this.initNetwork();
    });
  },

  computed: {
    jobOptions() {
      return this.$store.state.sandbox.sandboxJobs
        ? this.$store.state.sandbox.sandboxJobs.map((job) => {
            return { label: job.name, value: job.name };
          })
        : [];
    },
  },

  methods: {
    ...mapActions({
      fetchSandboxJobs: "sandbox/fetchSandboxJobs",
      createConfiguration: "amdp/createFlowSet",
      getJobTemplateGroups: "amdp/getJobTemplateGroups",
    }),
    async SelectTemplategroup() {
      let self = this;
      // let eventype = this.eventTypeTiles.filter(tile => this.configuration.eventType == tile.value)[0].title
      // let groupName = `${this.configuration.commercialIntegration.toLowerCase()}-${eventype.toLowerCase()}`
      // const filteredtemplategroups = this.jobTemplateGroups.filter((group) => {
      // 	// group.name
      // 	return group.name.startsWith(groupName)
      // })
      // this.groupId =  filteredtemplategroups.length?filteredtemplategroups[0].id:0;
      this.groupId = 77;
      if (this.$store.state.environment == "prod") {
        this.groupId = 2;
      } else if (this.$store.state.environment == "pre_prod") {
        this.groupId = 8;
      }

      this.mappingResponse = await this.$store.dispatch(
        "admin/getJobTemplateGroupMappings",
        this.groupId
      );

      // mappingResponse.data.map((mapData) => {
      // 	self.templateFields.push(JSON.parse(
      // 		mapData.template_fields
      // ));
      // console.log(self.templateFields);
      // templateFields.forEach((entry) => {
      // 	// Extract the fields from the entry
      // 	const { fields } = entry;

      // 	// Add each field to the dynamicFields object
      // 	fields.forEach((field) => {
      // 		this.templateDynamicFields[field.toUpperCase()] = this.dynamicFields[field.toUpperCase()]||""; // You can set an initial value if needed
      // 	});
      // });
    },
    async onCreateConfig() {
      let self = this;
      this.loading = true;
      let toastoptions;

      this.mappingResponse.data.map((mapData) => {
        const templateFields = JSON.parse(mapData.template_fields);
        templateFields.forEach((entry) => {
          const { fields } = entry;

          fields.forEach((field) => {
            try {
              const upperField = field.toUpperCase();

              if (field in this.deterministicConfig) {
                this.templateDynamicFields[upperField] =
                  this.deterministicConfig[field];
              } else if (field in this.cluster_node_config) {
                this.templateDynamicFields[upperField] =
                  this.cluster_node_config[field];
              } else if (this.clusterModeConfig.cluster_graph) {
                const clusterGraph = this.clusterModeConfig.cluster_graph;
                const sections = [
                  "flatten_graph",
                  "create_cluster",
                  "choose_cluster",
                  "final_graph",
                ];

                for (const section of sections) {
                  if (clusterGraph[section] && field in clusterGraph[section]) {
                    this.templateDynamicFields[upperField] =
                      clusterGraph[section][field];
                    break;
                  }
                }
              }

              // Set default if field not found
              if (!this.templateDynamicFields[upperField]) {
                this.templateDynamicFields[upperField] = "";
              }
            } catch (error) {
              console.error(`Error processing field ${field}:`, error);
              this.templateDynamicFields[field.toUpperCase()] = "";
            }
          });
        });
      });
      console.log(this.templateDynamicFields);
      let response;
      try {
        response = await this.createConfiguration({
          configuration: JSON.stringify(this.configuration),
          name: this.name,
          status: "INITIATED",
          type: "IDR",
          job_template_group_id: this.groupId,
          dynamic_fields: JSON.stringify(this.templateDynamicFields),
          sandbox_name: this.sandbox
        });
        this.flowset = response.data;
        toastoptions = {
          message: "Input stream created successfully.",
          type: "success",
        };
        //this.createJob();
      } catch (error) {
        toastoptions = {
          message:
            "Something went wrong when creating input stream. Please contact support.",
          type: "error",
        };
      }
      this.loading = false;
      this.$store.dispatch("addToast", toastoptions);
      this.$store.dispatch("hideModal");
      this.$router.push(`/${this.cid}/agm/configurator/${this.flowset.id}`);
    },
    convertWeightageMapToNetwork(weightageMap) {
      // Create nodes dataset
      const nodes = [];

      // Add central node
      nodes.push({
        id: "center",
        label: "Cluster",
        value: 100,
      });
      const edges = [];

      // Add nodes and edges for each weightage entry
      Object.entries(weightageMap).forEach(([key, weight], index) => {
        nodes.push({
          id: key,
          value: weight,
          label: `${key} (${weight})`,
        });
        edges.push({
          source: "center",
          target: key,
        });
      });

      return {
        nodes: nodes,
        edges: edges,
      };
    },
    handleEnter(event, key) {
      this.cluster_node_config.weightage_map[key] = event.target.value;
      this.updateGraph();
    },

    async updateGraph() {
      try {
        await this.initNetwork();
      } catch (error) {
        console.error("Search failed:", error);
      }
    },
    async initNetwork() {
      try {
        console.log("Inside initNetwork");

        const container = this.$refs.networkContainer;
        console.log(container);
        if (!container) {
          console.log("Network container not found");
          return;
        }

        const data = this.convertWeightageMapToNetwork(
          this.cluster_node_config.weightage_map
        );

        console.log("Network data:", data);
        
        if (!data || !data.nodes || !data.edges) {
          console.error("Invalid network data:", data);
          return;
        }

        console.log("Initializing network with data:", data);

        this.drawGraph(data)
      } catch (error) {
        console.log(error);
      }
    },
    drawGraph(data) {
        const width = this.$refs.networkContainer.clientWidth || 337;
        const height = this.$refs.networkContainer.clientHeight || 252;

        // Remove old SVG if it exists
        d3.select(this.$refs.networkContainer).select("svg").remove();

        // Create new SVG with zoom/pan support
        const svg = d3.select(this.$refs.networkContainer)
            .append("svg")
            .attr("width", width)
            .attr("height", height)
            .call(
                d3.zoom()
                    .scaleExtent([0.5, 5]) // Min zoom 50%, max zoom 500%
                    .on("zoom", (event) => {
                        g.attr("transform", event.transform);
                    })
            );

        // Add a group element for panning/zooming
        const g = svg.append("g");
        this.simulation = d3.forceSimulation(data.nodes)
            .force("link", d3.forceLink(data.edges).id(d => d.id).distance(75)) // edge distance
            .force("charge", d3.forceManyBody().strength(-200))
            .force("center", d3.forceCenter(width / 2, height / 2));

        // Create edges (links)
        const link = g.selectAll(".link")
            .data(data.edges)
            .enter()
            .append("line")
            .attr("stroke", "#1275ff")
            .attr("stroke-width", 1.5)
            .attr("stroke-opacity", 0.6);

        // Create node groups
        const node = g.selectAll(".node")
            .data(data.nodes)
            .enter()
            .append("g")
            .attr("class", "node")
            .call(
                d3.drag()
                    .on("start", (event, d) => {
                        if (!event.active) this.simulation.alphaTarget(0.3).restart();
                        d.fx = d.x;
                        d.fy = d.y;
                    })
                    .on("drag", (event, d) => {
                        d.fx = event.x;
                        d.fy = event.y;
                    })
                    .on("end", (event, d) => {
                        if (!event.active) this.simulation.alphaTarget(0);
                        d.fx = null;
                        d.fy = null;
                    })
            );

        // Add circles for nodes
        node.append("circle")
            .attr("stroke", "#1275ff") // Border color
            .attr("stroke-width", 1.0) // Border thickness
            .attr("r", d => { // Circle radius
                const radius = 5 + (d.value * 0.15);
                return radius < 5 ? 5 : radius > 20 ? 20 : radius
            })
            .attr("fill", d => {
                return "#94c0ff"; // Circle colour
            })
            .attr("class", "node-circle");

        // Add labels for all nodes
        node.append("text")
            .attr("dy", d => 15 + (d.value * 0.2)) // Vertically place text below circle based on size
            .attr("text-anchor", "middle") // Horizontally center text
            .text(d => d.label) // Display the label
            .attr("font-size", d => d.id === "center" ? "12px" : "10px")
            .attr("fill", d => {
              return "#000";
            })
            .attr("pointer-events", "none") // Make text non-interactive
            .attr("class", "node-label-primary");

        node.on("mouseover", function(event, d) {
            // Bold effect for the current node
            d3.select(this).select(".node-circle")
              .attr("stroke-width", 2.0)
              .attr("fill", "#bbd8ff");

            d3.select(this).select(".node-label-primary")
              .attr("font-weight", "bold");
        })

        node.on("mouseout", function(event, d) {
            // Restore normal appearance
            d3.select(this).select(".node-circle")
              .attr("stroke-width", 1.0)
              .attr("fill", "#94c0ff");
            
            d3.select(this).select(".node-label-primary")
              .attr("font-weight", "normal");
        })

        // // Tooltip for nodes
        // node.on("mouseover", (event, d) => {
        //     const tooltip = document.createElement("div");
        //     tooltip.innerHTML = `<strong>${d.label}</strong>`;
        //     tooltip.className = "graph-tooltip";
        //     tooltip.style.zIndex = 999999;
        //     tooltip.style.left = event.pageX + 5 + "px";
        //     tooltip.style.top = event.pageY + 5 + "px";
        //     document.body.appendChild(tooltip);
        // });
        // node.on("mouseout", () => {
        //     document.querySelectorAll(".graph-tooltip").forEach(tooltip => tooltip.remove());
        // });

        // Update positions on simulation tick
        this.simulation.on("tick", () => {
            link
                .attr("x1", d => d.source.x)
                .attr("y1", d => d.source.y)
                .attr("x2", d => d.target.x)
                .attr("y2", d => d.target.y);
            node.attr("transform", d => `translate(${d.x},${d.y})`);
        });
    },
    addWeightageEntry() {
      if (!this.newWeightageKey || !this.newWeightageValue) return;

      // Check if key already exists
      if (this.cluster_node_config.weightage_map[this.newWeightageKey]) {
        this.$toast.error("This key already exists!");
        return;
      }

      this.cluster_node_config.weightage_map[this.newWeightageKey] =
        this.newWeightageValue;
      this.updateGraph();

      // Clear input fields
      this.newWeightageKey = "";
      this.newWeightageValue = "";
    },

    deleteWeightageEntry(keyToDelete) {
      const { [keyToDelete]: deleted, ...rest } =
        this.cluster_node_config.weightage_map;
      this.cluster_node_config.weightage_map = rest;
      this.updateGraph();
    },
  },

  async beforeMount() {
    this.$store.dispatch("sandbox/setCurrentSandbox", "idr-edge-extract");
    await this.fetchSandboxJobs();
    await this.SelectTemplategroup();
  },

  beforeUnmount() {
    if (this.network) {
      this.network.destroy();
    }
  },
};
</script>

<style scoped>
.modal-lg {
  min-width: 1100px !important;
}
.config-div {
  padding: 25px;
}

.card-body {
  padding: 0.5rem 1rem;
}
.card-header {
  background-color: rgba(0, 0, 0, 0.03);
  height: 40px;
}

.network-wrapper {
  position: relative;
  width: 100%;
  padding-top: 75%; /* Aspect ratio 4:3 - adjust as needed */
}

.network-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #eee;
  background: #ffffff;
}
</style>